import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAll, postApproval } from "./brqaAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  approval: [],
};

export const fetchAll = createAsyncThunk("brqa/fetchAll", async (payload) => {
  const response = await getAll(payload);
  return response.data;
});

export const createApproval = createAsyncThunk(
  "brqa/createApproval",
  async (payload) => {
    const response = await postApproval(payload);
    return response;
  }
);

export const brqaSlice = createSlice({
  name: "brqa",
  initialState,
  reducers: {
    resetData: (state) => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
    setApproval: (state, action) => {
      state.approval = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAll.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.pageNo = action.payload.pageNo;
        state.pageSize = action.payload.pageSize;
        state.totalRecord = action.payload.totalRecord;
      })
      .addCase(createApproval.pending, (state) => {
        state.loading = true;
      })
      .addCase(createApproval.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createApproval.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { resetData, setSelected, setApproval } = brqaSlice.actions;

export const selectData = (state) => state.brqa.data;
export const selectLoading = (state) => state.brqa.loading;
export const selectError = (state) => state.brqa.error;
export const selectPageNo = (state) => state.brqa.pageNo;
export const selectPageSize = (state) => state.brqa.pageSize;
export const selectTotalRecord = (state) => state.brqa.totalRecord;
export const selectSelected = (state) => state.brqa.selected;
export const selectApproval = (state) => state.brqa.approval;

export default brqaSlice.reducer;
